export const TIME_DEGREE_OFFSET = 90

export const HOUR_LABELS = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]

export const DEFAULT_CLOCK_OPTIONS = {
  baseOptions: {
    baseColor: '#f1f8fa',
    labelColor: '#000',
    showNumbers: true,
    size: 500,
  },
  handColors: {
    hour: '#000',
    minute: '#000',
    second: '#000',
  },
}
